module.exports = __webpack_public_path__ + "static/media/Google-Cloud-Partnership.d14642f8.png";